import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TableModule } from 'primeng/table'
import { SharedModule } from '../shared/shared.module'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { InputTextModule } from 'primeng/inputtext'
import { SelectModule } from 'primeng/select'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ButtonModule } from 'primeng/button'
import { DialogModule } from 'primeng/dialog'
import { CheckboxModule } from 'primeng/checkbox'
import { TreeSelectModule } from 'primeng/treeselect'
import { TooltipModule } from 'primeng/tooltip'
import { ScrollingModule } from '@angular/cdk/scrolling'
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling'
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { SelectButtonModule } from 'primeng/selectbutton'
import { InputNumberModule } from 'primeng/inputnumber'
import { MatSortModule } from '@angular/material/sort'
import { MatIconModule } from '@angular/material/icon'
import { MatTableModule } from '@angular/material/table'
import { MatGridListModule } from '@angular/material/grid-list'
import { MatRadioModule } from '@angular/material/radio'
import { MatChipsModule } from '@angular/material/chips'
import { ProgressBarModule } from 'primeng/progressbar'
import { MatStepperModule } from '@angular/material/stepper'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { NgApexchartsModule } from 'ng-apexcharts'
import { MatTooltipModule } from '@angular/material/tooltip'
import { DVMToolLandingComponent } from './dvm-tool-landing/dvm-tool-landing.component'
import { DVMToolDashboardComponent } from './dvm-tool-dashboard/dvm-tool-dashboard.component'
import { DVMToolTeamDashboardComponent } from './dvm-tool-team-dashboard/dvm-tool-team-dashboard.component'
import { DVMToolPlanComponent } from './dvm-tool-plan/dvm-tool-plan.component'
import { ReviewAssessmentSectionsComponent } from './dvm-tool-plan/components/review-assessment-sections/review-assessment-sections.component'
import { ReportingDashboardComponent } from './reporting-dashboard/reporting-dashboard.component'
import { UserManagementComponent } from './reporting-dashboard/user-management/user-management.component'
import { DeferralRequestsComponent } from './reporting-dashboard/user-management/deferral-requests.component'
import { RolePermissionsComponent } from './reporting-dashboard/user-management/role-permissions.component'
import { HomeDashboardComponent } from './reporting-dashboard/home-dashboard/home-dashboard.component'
import { DvmToolRoutingModule } from './dvm-tool-routing.module'
import { HospitalProgressPanelComponent } from './dvm-tool-team-dashboard/hospital-progress-panel.component'
import { DVMToolTeamDashboardModalsComponent } from './dvm-tool-team-dashboard/dvm-tool-team-dashboard-modals.component'
import { AiInsightsComponent } from './reporting-dashboard/ai-insights/ai-insights.component'
import { DatePickerModule } from 'primeng/datepicker'
import { CyclesComponent } from './reporting-dashboard/user-management/cycles.component'
import { AdminSettingsComponent } from './reporting-dashboard/settings/admin-settings.component'
import { AdminMessagesComponent } from './reporting-dashboard/settings/messages/admin-messages.component'
import { PeerInputPanelComponent } from './dvm-tool-plan/components/peer-input-panel/peer-input-panel.component'
import { PeerInputPageComponent } from './dvm-tool-plan/peer-input-page/peer-input-page.component'


@NgModule({
   declarations: [
      DVMToolLandingComponent,
      DVMToolDashboardComponent,
      DVMToolTeamDashboardComponent,
      DVMToolPlanComponent,
      ReviewAssessmentSectionsComponent,
      ReportingDashboardComponent,
      UserManagementComponent,
      DeferralRequestsComponent,
      RolePermissionsComponent,
      HomeDashboardComponent,
      HospitalProgressPanelComponent,
      DVMToolTeamDashboardModalsComponent,
      AiInsightsComponent,
      CyclesComponent,
	  AdminSettingsComponent,
	  AdminMessagesComponent,
	  PeerInputPanelComponent,
	  PeerInputPageComponent,
   ],
   imports: [
      CommonModule,
      SharedModule,
      DvmToolRoutingModule,
      AutoCompleteModule,
      ButtonModule,
      CheckboxModule,
      DialogModule,
      FormsModule,
      SelectModule,
      InputTextModule,
      TableModule,
      TreeSelectModule,
      TooltipModule,
      ScrollingModule,
      CdkVirtualScrollViewport,
      OverlayPanelModule,
      InputNumberModule,
      SelectButtonModule,
      MatSortModule,
      MatIconModule,
      MatTableModule,
      MatGridListModule,
      MatRadioModule,
      MatChipsModule,
      MatTooltipModule,
      ProgressBarModule,
      MatStepperModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatInputModule,
      NgApexchartsModule,
      DatePickerModule,
   ],
})
export class DvmToolModule {}
